<template>
  <div class="CSChatThai" >
    <!-- <Navbar/> -->
    <div class="page-content page-content-show">



<div class="DocumentPage hidden-sm-and-down">
  <!-- <aside class="DocumentPage__menu" style="    overflow: scroll;
    height: 94vh;">
  <div class="DocumentPage__menuGroup js-toggle-group" v-for="item in items" :value="item.active">
    <h3 class="groupTitle" slot="item">
      {{ item.title }}
    </h3>
    <ul class="DocumentPage__menuGroupList">

        <router-link tag="li" :to="subItem.link" class="listItem" v-for="subItem in item.items"  @click.native="activech(subItem.link)">
          <span  class="active" v-if="active==subItem.link"><i class="fas fa-angle-double-right"></i> {{ subItem.title }}</span>
          <span v-else>{{ subItem.title }}</span>
        </router-link>
    </ul>
  </div>
</aside> -->

  <section class="DocumentPage__content">
  <div class="_make-article">
    <router-view></router-view>
  </div>
</section>

</div>


<div class="hidden-md-and-up">
  <v-layout  style="" row wrap>
    <v-flex xs12 md12 style=" height: auto; padding-top: 14vh; display: flex; justify-content: center; width: 100%; background: #fafafa !important; float: none; border-right: 0;">
      <v-expansion-panel focusable>
        <v-expansion-panel-content
          v-for="item in items"
          :value="item.active"
          :key="item"
        >
          <div slot="header" style="font-size: 18px;">{{ item.title }}</div>
          <v-list style="width: 100%;height: auto; padding-left: 0px !important;">
            <v-list-tile v-for="(subItem, index_sub) in item.items" :key="index_sub" @click="link(subItem.link)" >
              <v-list-tile-action style="padding-left: 7vw;">
                <v-icon  outline>{{subItem.icon}}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title style="padding-left: -3vw !important;">{{ subItem.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
        <!-- <v-list style="width: 100%;height: auto; padding-left: 0px !important;">
          <v-list-group v-for="item in items" :value="item.active" >
            <v-list-tile slot="item" @click="">
              <v-list-tile-content>
                <v-list-tile-title style="padding-left: 1vw !important;">{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon>keyboard_arrow_down</v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile v-for="subItem in item.items" @click="link(subItem.link)" >
              <v-list-tile-action style="padding-left: 7vw;">
                <v-icon  outline>{{subItem.icon}}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title style="padding-left: -3vw !important;">{{ subItem.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
        </v-list> -->
    </v-flex>
    <v-flex xs12 sm12 >
      <section class="DocumentPage__contentmo">
        <div class="" >
          <router-view ></router-view>
        </div>
      </section>
    </v-flex>
  </v-layout>
 <!-- <a href="#0" class="cd-top js-cd-top">Top</a> -->
</div>








      </div>
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbarapi'
export default {
  components: {
    Navbar
  },
  data: () => ({
    items: [
      {
        action: 'local_activity',
        title: 'เริ่มต้นการใช้งาน',
        active: true,
        items: [
          {title: 'เริ่มต้นการใช้งาน API', link: '/develop/docs', icon: 'info'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'คู่มือการใช้งาน API',
        active: false,
        items: [
          {title: 'การยืนยันตัวตน', link: '/develop/docs/authorization', icon: 'person'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การส่งข้อความ',
        active: false,
        items: [
          {title: 'การส่งข้อความ', link: '/develop/docs/webhook/reply_message', icon: 'fas fa-comment-alt'},
          {title: 'การส่งไฟล์', link: '/develop/docs/webhook/reply_file', icon: 'fas fa-file'},
          {title: 'การส่งโลเคชัน', link: '/develop/docs/webhook/reply_location', icon: 'map'},
          {title: 'การส่งสติ๊กเกอร์', link: '/develop/docs/webhook/reply_sticker', icon: 'photo'},
          {title: 'การส่งเว็บวิว', link: '/develop/docs/webhook/reply_webview', icon: 'web'},
          {title: 'การส่งแบบฟอร์มการยืนยัน', link: '/develop/docs/webhook/reply_approve', icon: 'far fa-thumbs-up'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การส่งเทมเพลต',
        active: false,
        items: [
          {title: 'เกี่ยวกับ Template', link: '/develop/docs/template/abouttemplate', icon: 'info'},
          {title: 'ประเภทข้อความ', link: '/develop/docs/template/template_message', icon: 'chat'},
          {title: 'ประเภทลิงก์', link: '/develop/docs/template/template_link', icon: 'link'},
          {title: 'ประเภทเว็บวิว', link: '/develop/docs/template/template_webview', icon: 'web'},
          {title: 'ประเภทไฟล์', link: '/develop/docs/template/template_file', icon: 'fas fa-file'}
        ]
      },
      // {
      //   action: 'far fa-file-code',
      //   title: 'การจัดการบอท',
      //   active: false,
      //   items: [
      //     {title: 'การเพิ่มบอท', link: '/docs/manage_bot/add', icon: 'add_circle'},
      //     {title: 'แสดงบอททั้งหมด', link: '/docs/manage_bot/show', icon: 'list'},
      //     {title: 'การลบบอท', link: '/docs/manage_bot/remove', icon: 'delete'},
      //     {title: 'กำหนดชื่อ', link: '/docs/manage_bot/edit_name', icon: 'settings'},
      //     {title: 'กำหนดสเตตััส', link: '/docs/manage_bot/edit_status', icon: 'edit'},
      //     {title: 'กำหนดรูปภาพของบอท', link: '/docs/manage_bot/edit_picturebot', icon: 'photo'},
      //     {title: 'กำหนดwebhook', link: '/docs/manage_bot/edit_webhook', icon: 'web'},
      //     {title: 'กำหนดข้อความต้อนรับ', link: '/docs/manage_bot/edit_welcomemessage', icon: 'chat_bubble'}
      //   ]
      // },
      {
        action: 'far fa-file-code',
        title: 'รายละเอียด webhook',
        active: false,
        items: [
          {title: 'การรับข้อความ', link: '/develop/docs/webhook/recieve', icon: 'add_circle'},
          {title: 'การตอบกลับด้วยข้อความ', link: '/develop/docs/webhook/reply_message', icon: 'edit'},
          {title: 'การตอบกลับด้วยไฟล์', link: '/develop/docs/webhook/reply_file', icon: 'delete'}
        ]
      }
      // {
      //   action: 'far fa-file-code',
      //   title: 'การตอบกลับข้อความอัตโนมัติ',
      //   active: false,
      //   items: [
      //     {title: 'การเพิ่ม', link: '/docs/reply_message/add', icon: 'add_circle'},
      //     {title: 'การแก้ไข', link: '/docs/reply_message/edit', icon: 'edit'},
      //     {title: 'การลบ', link: '/docs/reply_message/remove', icon: 'delete'},
      //     {title: 'แสดงข้อความทั้งหมด', link: '/docs/reply_message/show', icon: 'list'}
      //   ]
      // }
    ],
    active: '/develop/docs'
    // items: [
    //   {src: '/static/image/ios_photo/ios_friend.png'},
    //   {src: '/static/image/ios_photo/ios_login.png'}
    // ]
  }),
  created () {
    this.active = this.$router.currentRoute.path
  },
  methods: {
    link (link) {
      this.$router.push(link)
    },
    activech (link) {
      // console.log(link)
      this.active = link
      // console.log(this.active)
    }
  }
}
</script>

<style type="text/css" scoped>
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.DocumentPage__menuGroup.-is-aritcle-vertioning {
    padding-right: 32px;
}
.DocumentPage {
    max-width: 1040px;
    margin-left: auto;
    margin-right: auto;

    margin-top: 1px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: #FFFFFF;
}
.DocumentPage__menu {
  position: fixed;
    float: left;
    width: 10%;
    padding-top: 18vh;
    padding-bottom: 48px;
}
article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary {
    display: block;
}
.DocumentPage__menuGroup {
    position: relative;
    margin-bottom: 40px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.DocumentPage__menuGroupList {
    margin: 0;
    padding: 0;
}
.DocumentPage__menuGroupList>.listItem {
    position: relative;
    margin-bottom: 15px;
    list-style: none;
    color: #1976D2;
    cursor: pointer;
}
.active {
    color: #636363;
}
.DocumentPage__menuGroup>.groupTitle {
    position: relative;
    margin-bottom: 8px;
    color: #04070D;
    font-size: 12px;
    text-transform: uppercase;
}
.DocumentPage__content {
    float: left;
    width: 73%;
    margin-left: 0vw;
    /*padding-top: 20vh;*/
    /*/*padding-left: 40px;*/
    padding-right: 1px;
    padding-bottom: 48px;
}
.DocumentPage__contentmo {
   float: left;
    width: 73%;
    margin-left: 5vw;
    /*/*padding-left: 40px;*/
    padding-right: 1px;
    padding-bottom: 48px;
    /*overflow-x: hidden;*/
}
._make-article {
    line-height: 1.5em;
}
.DocumentPage .ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
.CustomSelectBox {
    position: relative;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
>>>.list--group .list__tile {
    padding-left: 7vw;
}

</style>



// WEBPACK FOOTER //
// src/components/home/ApiHomepage.vue